"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("react");
const client_1 = require("react-dom/client");
const App_1 = __importDefault(require("./App"));
const ToastService_1 = require("./Services/ToastService");
const LoadingService_1 = require("./Services/LoadingService");
const rootElement = document.querySelector('.react-app-uniforms');
if (rootElement) {
    rootElement.id = 'react-app-uniforms';
    const root = (0, client_1.createRoot)(rootElement);
    root.render(react_1.default.createElement(ToastService_1.ToastProvider, null,
        react_1.default.createElement(LoadingService_1.LoadingProvider, null,
            react_1.default.createElement(react_2.StrictMode, null,
                react_1.default.createElement(App_1.default, null)))));
}
